import React from 'react';
import FrontLoader from './FrontLoader';
import './page-loading-shell.scss';

type PageLoaderOverlayProps = {
  /** When true, shows frosted full-page loader (same blur as Home). */
  show: boolean;
};

/** Full-page blurred logo loader for in-page actions (reject, etc.). */
export default function PageLoaderOverlay({ show }: PageLoaderOverlayProps) {
  if (!show) return null;

  return (
    <div className="page-loading-shell page-loading-shell--loading page-loading-shell--overlay" aria-hidden="true">
      <FrontLoader />
    </div>
  );
}
